//Core modules
import React from 'react';

//Internal modules
import {useSettingsContext} from "./context/settingsContext";
import SettingsContainer from "./settingsContainer";
import Common from "../../Common/Common";

const Settings = (props) => {

    const {
        showLoader
    } = useSettingsContext();

    return (
        <>
            <Common pageTitle={"Settings"} showLoader={showLoader} customClass="no-padding" mainContent={
                <SettingsContainer {...props} />
            }/>
        </>
    )
}

export default Settings;